/** @typedef	{import('./Props').default} Props */

import { BaseSVG } from '../../BaseSVG';
import { translate } from '../../../App/Internationalization';
import images from '../../../config/local/images';
import PopularHeader from '../PopularHeader';
import React from 'react';
import SubscribeButton from '../SubscribeButton';
import SubscriptionPoints from '../SubscriptionPoints';
import SubscriptionPrice from '../SubscriptionPrice/SubscriptionPrice';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function SubscriptionCard(props) {
	const popular = props?.tier?.popular ?? false;

	return (
		<section
			className={`flex flex-col gap-4 text-left border border-theme-dark rounded-lg w-fit p-10 ${
				popular
					? 'border-theme-light bg-theme-light text-theme-fg-light'
					: ''
			}
			`}
		>
			<PopularHeader popular={popular ?? false} />

			<i
				className={`flex w-25 icon ${
					popular ? 'icon-fill-fg-light' : ''
				}`}
			>
				<BaseSVG
					className="h-fit"
					path={images.icons.subscriptionPlans[props?.tier?.title]}
				/>
			</i>

			<p className="font-bold text-ms-4">
				{translate(`subscription.plans.${props?.tier?.title}.title`)}
			</p>

			<p className="lg:min-h-[7rem] font-medium">
				{props?.tier?.description}
			</p>

			<SubscriptionPrice
				checkoutRole={props?.checkoutRole}
				price={props?.tier?.pricePerMonth}
			/>

			<SubscribeButton
				isGettingData={props?.isGettingData}
				paymentLinks={props?.paymentLinks}
				tier={props?.tier}
			/>

			<SubscriptionPoints features={props?.tier?.features} />
		</section>
	);
}

export default React.memo(SubscriptionCard);
